import { Building2, Users } from "lucide-react";

// Welcome screen — the wizard's header carries the ~2–3 minute expectation;
// this names the two things the wizard builds: the public profile agents see,
// and the inputs agent matching runs on.
const OrgOnboardingStep1 = () => {
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      <div className="flex items-start gap-3 rounded-xl border border-border p-4">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10">
          <Building2 className="h-5 w-5 text-primary" />
        </span>
        <div>
          <p className="text-sm font-semibold text-foreground">Your public story</p>
          <p className="mt-0.5 text-xs text-muted-foreground">Brand, story, value, and what you offer — all in one place.</p>
        </div>
      </div>
      <div className="flex items-start gap-3 rounded-xl border border-border p-4">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10">
          <Users className="h-5 w-5 text-primary" />
        </span>
        <div>
          <p className="text-sm font-semibold text-foreground">Better agent matches</p>
          <p className="mt-0.5 text-xs text-muted-foreground">The more you share, the more accurately we surface you to agents who fit.</p>
        </div>
      </div>
    </div>
  );
};

export default OrgOnboardingStep1;
